import { MUTATION_KEYS, QUERY_KEYS, LOCIZE_NS } from '@avanta/shared/constants/common';
import { useDialogContext } from '@avanta/shared/contexts/Dialog';
import { type UpdateAdminEnterprisePayload } from '@avanta/shared/types/enterprises';
import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { type AxiosError, type AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { EnterprisesService } from 'services/enterprises';
import { type AdminEnterprise } from 'types/enterprises';

export const useEditAdmin = (
  adminId: string
): UseMutationResult<AxiosResponse<AdminEnterprise>, AxiosError, UpdateAdminEnterprisePayload> => {
  const queryClient = useQueryClient();
  const { hideDialog } = useDialogContext();
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  return useMutation({
    mutationKey: [MUTATION_KEYS.CREATE_ADMIN],
    mutationFn: async (payload: UpdateAdminEnterprisePayload) =>
      await EnterprisesService.editAdmin(adminId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_ADMINS] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_ADMINS_COUNT] });
      toast.success(t('InsuranceAdministrators.editAdmin.success'));
      hideDialog();
    },
    onError: () => toast.error(t('InsuranceAdministrators.editAdmin.error')),
  });
};
